/**
 * Returns a filter function for sales records based on the user's plan.
 * Core: only records within the last 2 months (current + previous).
 * Pro: no filter — returns all records.
 *
 * Usage: sales.filter(getHistoryFilter(planConfig))
 */
export function getHistoryFilter(planConfig) {
  if (!planConfig || planConfig.salesHistoryMonths === null) {
    // Pro — no restriction
    return () => true;
  }

  const now = new Date();
  const months = planConfig.salesHistoryMonths || 2;
  // Start of (current month - (months - 1))
  const cutoff = new Date(now.getFullYear(), now.getMonth() - (months - 1), 1);

  return (record) => {
    const date = new Date(record.soldDate || record.date || record.createdAt);
    return date >= cutoff;
  };
}
